const mutations = {
  APPEND_DELIVERIES(state, data) {
    const newEntries = [];
    data.forEach((entry) => {
      newEntries.push({ ...entry, checked: state.allDeliveriesSelected });
    });
    state.all.push(...newEntries);
    state.page += 1;
  },
  UPDATE_MATERIAL_FILTER(state, data) {
    state.materialFilter = data;
  },
  PAGINATION_CHECK(state, data) {
    state.disablePagination = data;
  },
  RESET_STATES(state) {
    state.page = 1;
    state.all = [];
    state.disablePagination = false;
    state.allDeliveriesSelected = false;
  },
  RESET_MATERIAL_STATES(state) {
    state.materialsAvailable = true;
  },
  SET_FILTER(state, data) {
    state.filter = data;
  },
  UPDATE_SELECT_ALL(state, data) {
    state.allDeliveriesSelected = data;
  },
  SET_REQUEST_DETAILS(state, data) {
    state.requestDetails = data;
  },
  DELETE_DELIVERY(state, { rowIndex, indentNo }) {
    state.requestDetails.materialsData[indentNo].splice(rowIndex, 1);
    let materialsAvailable = false;
    const materialsData = state.requestDetails.materialsData;
    const indentNos = Object.keys(state.requestDetails.materialsData);
    for (let itr = 0; itr < indentNos.length; itr += 1) {
      if (materialsData[indentNos[itr]].length) {
        materialsAvailable = true;
        break;
      }
    }
    state.materialsAvailable = materialsAvailable;
  },
  SET_MASTER_VEHICLE_LIST(state, data) {
    state.masterVehicleList = data;
  },
  RESET_PAGINATION(state) {
    state.transporterPagination = 1;
    state.gateListingPagination = 1;
    state.masterTransporterList = [];
    state.mdmGateList = [];
  },
  SET_MASTER_TRANSPORTER_LIST(state, data) {
    const updatedData = data.map(entry => ({ ...entry, name: `${entry.name} - ${entry.reference_id}` }));
    const result = (state.transporterPagination > 1) ? state.masterTransporterList.concat(updatedData) : updatedData;
    state.masterTransporterList = result;
    if (updatedData.length) {
      state.transporterPagination += 1;
    }
  },
  SET_NO_FREIGHT_TRANSPORTERS(state, data) {
    state.noFreightTransporterList = data.map(entry => ({ ...entry, name: `${entry.name} - ${entry.reference_id}` }));
  },
  SET_MDM_GATE_LIST(state, data) {
    const updatedData = data.map(entry => ({
      gate_id: entry.gate.id,
      location_id: entry.id,
      ref_id: entry.gate.reference_id,
      location_ref_id: entry.reference_id,
      name: entry.gate.name,
    }));
    const result = (state.gateListingPagination > 1)
      ? state.mdmGateList.concat(updatedData)
      : updatedData;
    state.mdmGateList = result;
    if (updatedData.length) {
      state.gateListingPagination += 1;
    }
  },
  APPEND_REQUESTS(state, data) {
    state.all.push(...data);
    state.page += 1;
  },
};
export default mutations;
